import React from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router';
import { alpha, Box, Card, CardContent, Typography, useTheme } from '@mui/material';
import { useForm } from '@fuse/hooks';
import FuseLoading from '@fuse/core/FuseLoading';

import jwtService from 'app/auth/services/jwtService';
import LoginTab from './components/LoginTab';
import AppSelectionTab from './components/AppSelectionTab';

export default function LoginPage() {
	const { search } = useLocation();
	const theme = useTheme();
	const searchParams = new URLSearchParams(search);
	const tokenParam = searchParams.get('token');
	const redirectApp = searchParams.get('redirectApp');
	const redirectTo = searchParams.get('redirectTo');

	const { form, handleChange } = useForm({ email: '', password: '' });

	const [availableApps, setAvailableApps] = React.useState<any[] | undefined>();

	document.title = `Login | ${import.meta.env.VITE_TITLE}`;

	if (tokenParam) {
		jwtService.setRefreshToken(tokenParam);
		jwtService.refreshTokens();

		return <FuseLoading />;
	}

	return (
		<Box
			className="flex flex-auto shrink-0 flex-col items-center justify-center p-16 md:p-24"
			sx={{
				background: theme.palette.primary.dark,
				color: theme.palette.primary.contrastText
			}}
		>
			<motion.div
				className="flex w-full max-w-400 overflow-hidden rounded-20 shadow-2xl md:max-w-3xl"
				initial={{ opacity: 0, scale: 0.6 }}
				animate={{ opacity: 1, scale: 1 }}
			>
				<div className="flex w-full max-w-400 overflow-hidden rounded-12 shadow-2xl md:max-w-3xl">
					<Card className="flex w-full max-w-sm flex-col items-center justify-center" square elevation={0}>
						<CardContent className="flex w-full max-w-320 flex-col items-center justify-center py-96">
							<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 0.2 } }}>
								<div className="flex items-center">
									{/* {logo || <Logo />}
									<div className="m-8 h-40 w-1 border-l-1" /> */}
									<div>
										<img
											className="w-full"
											src="assets/images/logo/perceptive-logo-full.svg"
											alt="logo"
										/>
										{/* <Typography className="mt-32 text-2xl font-800">Accedi</Typography> */}
									</div>
								</div>
							</motion.div>
							{!availableApps ? (
								<LoginTab
									form={form}
									handleChange={handleChange}
									onSuccessLogin={apps => setAvailableApps(apps)}
								/>
							) : (
								<AppSelectionTab
									form={form}
									availableApps={availableApps}
									redirectApp={redirectApp}
									redirectTo={redirectTo}
								/>
							)}
						</CardContent>
						<div className="flex flex-col items-center justify-center pb-32">
							{/* <span className="font-medium">Don't have an account?</span>
							<Link className="font-medium" to="/pages/auth/register-3">
								Create an account
							</Link> */}
							<p>
								Made by&nbsp;
								<a
									target="_blank"
									rel="noopener noreferrer"
									href="https://www.wisesolutions.it"
									className="text-teal font-600"
								>
									WISE SOLUTIONS
								</a>
							</p>
						</div>
					</Card>
					<Box
						className="hidden flex-1 items-center justify-center p-64 md:flex"
						sx={{
							background: `
								linear-gradient(to right, ${alpha(theme.palette.secondary.dark, 0.5)}, ${alpha(theme.palette.secondary.light, 0.5)}), 
								url(https://picsum.photos/1280/853/?grayscale&random=1)
							`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							color: theme.palette.secondary.contrastText
						}}
					>
						<div className="max-w-320">
							<motion.div
								initial={{ opacity: 0, y: 40 }}
								animate={{ opacity: 1, y: 0, transition: { delay: 0.2 } }}
							>
								<Typography variant="h3" color="inherit" className="font-800 leading-tight">
									Welcome to <br /> PERCEPTIVE HRM!
								</Typography>
							</motion.div>
							<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 0.3 } }}>
								<Typography variant="subtitle1" color="inherit" className="mt-32 font-800">
									Powerful and professional Human Resources Management software and much more.
								</Typography>
							</motion.div>
						</div>
					</Box>
				</div>
			</motion.div>
		</Box>
	);
}
